export const theme = {
  colors: {
    // 브랜드 컬러 (로고에서 추출)
    primary: '#223E7E',    // 로고 블루 (메인)
    secondary: '#16294f',  // 짙은 블루 (호버용)
    accent: '#E67A25',     // 로고 오렌지 (강조/포인트)
    important: '#AF2625',  // 로고 레드 (중요 표시)
    neutral: '#858689',    // 로고 그레이 (DOOSUNG 글자)
    // 시스템 컬러
    lightGray: '#f8f9fa',  // 섹션 배경색
    textMain: '#222222',
    textSub: '#666666',
    border: '#dddddd',
    white: '#ffffff',
    // 본문보다 흐린 보조 텍스트. 회색을 따로 쓰는 대신 본문색을 투명도로 눌러
    // 배경이 바뀌어도 톤이 자연스럽게 따라오게 한다.
    muted: 'rgba(34, 34, 34, 0.68)'
  },

  /*
   * 타이포그래피 스케일
   * clamp(최소, 뷰포트비율, 최대) 방식이라 화면 폭에 따라 글자가 매끄럽게 커진다.
   * 미디어쿼리로 단계별로 끊는 것보다 중간 크기 화면에서 자연스럽다.
   */
  type: {
    display: 'clamp(38px, 6vw, 76px)',      // 페이지 최상단 대표 문구
    title: 'clamp(30px, 4.2vw, 54px)',      // 섹션 제목
    subtitle: 'clamp(23px, 2.8vw, 36px)',   // 섹션 소제목
    cardTitle: 'clamp(19px, 1.8vw, 26px)',  // 카드 제목
    lede: 'clamp(16px, 1.4vw, 20px)',       // 제목 아래 도입 문단
    body: '16px',
    small: '14px',
    eyebrow: '13px'                         // 제목 위 작은 라벨
  },

  /*
   * 자간(letter-spacing)
   * 한글은 자간을 음수로 좁혀야 덩어리로 읽히고, 글자가 클수록 더 좁혀야 한다.
   * 반대로 eyebrow처럼 작은 대문자 라벨은 양수로 벌려야 읽힌다.
   */
  tracking: {
    display: '-0.055em',
    title: '-0.05em',
    card: '-0.045em',
    body: '-0.03em',
    eyebrow: '0.08em'
  },

  /* 굵기 - Pretendard Variable이라 100 단위가 아닌 값도 쓸 수 있다 */
  weight: {
    body: 500,
    medium: 650,
    bold: 800,
    heavy: 900
  },

  layout: {
    content: '1240px',     // 본문 최대 폭
    gutter: '40px',        // 데스크탑 좌우 여백
    gutterMobile: '20px'
  },

  spacing: {
    padding: '40px',
    sectionMargin: '80px'
  }
};
